<template>
  <div class="flex-container">
    <el-breadcrumb class="flex-item" separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/sys/linXuanChannel/list' }"
      >{{title}}</el-breadcrumb-item>
      <el-breadcrumb-item>渠道列表</el-breadcrumb-item>
    </el-breadcrumb>
    <el-form
        class="flex-item search-form"
        size="mini"
        :inline="true"
        :model="searchForm"
        style="text-align: left; margin-top: 15px"
    >
      <el-row>
          <el-form-item>
            <el-form-item label="搜索词:">
              <el-input v-model="searchForm.keyword" clearable placeholder="请输入渠道/商户/门店名称" @change="changekeyword"></el-input>
            </el-form-item>
            <el-form-item label="申报类型:">
              <el-select
                  v-model="searchForm.wfType"
                  placeholder="请选择申报类型"
                  clearable
                  @change="selectWfType">
                <!-- ========== userRole='2' 的基础选项 ========== -->
                <template v-if="userRole === '2'">
                  <el-option value="1" key="1" label="渠道遴选" />
                  <el-option value="2" key="2" label="新增商户/门店" />
                  <el-option value="4" key="4" label="修改商户/门店" />
                  <el-option value="3" key="3" label="退出商户/门店" />
                  <el-option value="5" key="5" label="渠道退出" />
                  <el-option value="6" key="6" label="支付业务许可证" />
                </template>

                <!-- ========== userRole='3' 的细化选项 ========== -->
                <template v-else-if="userRole === '3'">
                  <el-option value="1" key="1" label="渠道遴选" />

                  <!-- wf_type='2' 细分 -->
                  <el-option value="2" key="2" label="新增商户/门店" />
                  <el-option value="2-1" key="2-1" label="老商户新增门店" />

                  <!-- wf_type='3' -->
                  <el-option value="3" key="3" label="退出门店" />

                  <!-- wf_type='4' 细分 -->
<!--                  <el-option value="4" key="4" label="修改商户/门店" />-->
                  <el-option value="4-1" key="4-1" label="修改门店" />
                  <el-option value="4-2" key="4-2" label="修改商户" />

                  <el-option value="5" key="5" label="渠道退出" />
                  <!-- wf_type='6' -->
                  <el-option value="6" key="6" label="支付业务许可证" />
                </template>

              </el-select>
            </el-form-item>
            <el-form-item label="状态:">
              <el-select v-model="searchForm.auditState" placeholder="请选择状态" clearable @change="selectAuditStatus"
                         >
                <el-option
                    v-for="item in auditList"
                    :key="item.value"
                    :value="item.value"
                    :label="item.label"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="经营模式:" v-if="userRole!='1'">
              <el-select v-model="searchForm.saleModel" placeholder="请选择经营模式" clearable @change="selectSaleModel">
                <el-option value="0" key="0" label="线上" />
                <el-option value="1" key="1" label="线下" />
              </el-select>
            </el-form-item>
            <el-form-item label="渠道名称:" prop="channelNo" v-if="userRole!='1'">
              <el-select filterable style="width: 100%" v-model="searchForm.channelName" clearable placeholder="请选择渠道">
                <el-option v-for="item in channelList" :key="item.id" :label="item.channel_name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
            <br/>
              <el-button type="primary" @click="onSearch">查询</el-button>
            <el-button type="primary" @click="downloadTemplate()" v-if="userRole==='1'">模板下载</el-button>
            <el-button type="primary" @click="channelDeclare()" v-show="isShowCDbut">渠道申报</el-button>
            <!--<el-button type="primary" @click="channelExit()" v-if="userRole==='1'">渠道退出</el-button>-->
            <el-button type="primary" @click="addMerchant(2)" v-if="userRole==='1' && isShowMerchantBut">新增商户/门店</el-button>
            <el-button type="primary" @click="addMerchant(4)" v-if="userRole==='1' && isShowMerchantBut">修改商户/门店</el-button>
            <el-button type="primary" @click="addMerchant(3)" v-if="userRole==='1' && isShowMerchantBut">退出商户/门店</el-button>
            <el-button type="primary" @click="fileParse()" v-if="userRole==='2'">文件解析</el-button>
<!--              <el-button type="primary" @click="queryMerchantByTyc()" v-if="userRole==='2'">商户数据校验</el-button>-->
              <el-button type="primary" @click="batchApprove()" v-if="userRole==='2' || userRole==='3'">批量审批</el-button>
              <el-button type="primary" @click="batchPublicity()" v-if="userRole==='3'">批量公示</el-button>
              <el-button type="primary" @click="setJoinOrExitDate('0')" v-if="userRole==='3'">批量外网通知/实施</el-button>
            <!-- <el-button type="primary" @click="batchAudit('3')" v-if="userRole==='3'">渠道商户门店违规退出</el-button>
            <el-button type="primary" @click="exportExcel('0')" v-if="userRole==='2' || userRole==='3'">导出渠道</el-button>
            <el-button type="primary" @click="exportExcel('1')" v-if="userRole==='2' || userRole==='3'">导出商户</el-button>
            <el-button type="primary" @click="exportExcel('2')" v-if="userRole==='2' || userRole==='3'">导出门店</el-button> -->
            <el-button type="primary" @click="exportExcel('3')">终审通过导出(含退出)</el-button>
            <!-- <el-button type="primary" @click="exportExcel('4')" v-if="userRole==='3'">提数</el-button> -->
          </el-form-item>
      </el-row>
    </el-form>
    <div class="table-page">
    <el-table ref="multipleTable" v-loading="tableLoading" size="small" border
        :data="tableData"
        :height="tableHeight"
        style="width: 100%;"
        row-key="id"
        lazy
        :load="loadNode"
        show-select-all="true"
        :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
        @selection-change="handleSelectionChange"
        @expand-change="handleExpandChange"
        >
      <el-table-column :type="selection" width="50" v-if="userRole==='2'||userRole==='3'" :reserve-selection="true" align="center">
        <template slot-scope="scope">
          <el-checkbox
              :indeterminate="scope.row.indeterminate"
              v-model="scope.row.checked"
              @change="handleCheckChange(scope.row, scope.$index)"
              :disabled="getCheckboxDisabled(scope.row)"
          ></el-checkbox>
        </template>
      </el-table-column>
      <el-table-column
          align="center"
          width="67px"
          type="index"
          label="序号">
        <template slot-scope="scope">
          <span>{{ getFirstLevelIndex(scope.row) }}</span>
        </template>
      </el-table-column>
      <el-table-column
          prop="cmsName"
          align="left"
          min-width="125px"
          label="渠道/商户/门店名称">
      </el-table-column>
      <el-table-column
          prop="creditCode"
          align="center"
          min-width="110px"
          label="统一信用代码/门店编号">
      </el-table-column>
      <el-table-column
          prop="saleModel"
          align="center"
          min-width="70px"
          label="经营模式">
        <template slot-scope="scope">
          <span v-if="scope.row.saleModel==='0'">线上</span>
          <span v-else-if="scope.row.saleModel==='1'">线下</span>
        </template>
      </el-table-column>
      <el-table-column
          prop="regLocation"
          align="center"
          min-width="70px"
          label="所属区域">
        <template slot-scope="scope">
          <el-tooltip placement="top" effect="light">
            <div slot="content">
              {{scope.row.regLocation}}
            </div>
            <span>{{
                scope.row.regLocation && scope.row.regLocation.length > 5 ? scope.row.regLocation.slice(0, 5)+'...' : scope.row.regLocation || ''
              }}
            </span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column
          prop="officeAddress"
          align="center"
          min-width="90px"
          label="注册地址">
        <template slot-scope="scope">
          <el-tooltip placement="top" effect="light">
            <div slot="content">
              {{scope.row.officeAddress}}
            </div>
            <span>{{
                scope.row.officeAddress && scope.row.officeAddress.length > 10 ? scope.row.officeAddress.slice(0, 10)+'...' : scope.row.officeAddress || ''
              }}
            </span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column
          prop="wfType"
          align="center"
          min-width="70px"
          label="申报类型">
          <template slot-scope="scope">
            <span v-if="userRole!=='2'">{{ scope.row.wfType }}</span>
            <template v-if="userRole==='2' || scope.row.level === '2'">
              <span v-if="scope.row.wfType === '1'">渠道遴选</span>
              <span v-else-if="scope.row.wfType === '2'">新增商户/门店</span>
              <span v-else-if="scope.row.wfType === '3'">退出商户/门店</span>
              <span v-else-if="scope.row.wfType === '4'">修改商户/门店</span>
              <span v-else-if="scope.row.wfType === '5'">渠道退出</span>
              <span v-else-if="scope.row.wfType === '6'">支付业务许可证</span>
            </template>
          </template>
      </el-table-column>
      <el-table-column
          prop="createTime"
          align="center"
          min-width="75px"
          label="创建时间" v-if="userRole==='2'">
      </el-table-column>
      <el-table-column
          prop="updateTime"
          align="center"
          min-width="75px"
          label="更新时间" v-if="userRole==='2'">
      </el-table-column>
      <el-table-column
          prop="auditStateDesc"
          label="状态"
          align="center"
          min-width="100px"
      >
          <template slot-scope="scope">
            <span style="color: green">{{scope.row.auditStateDesc}}</span>
          </template>
      </el-table-column>
      <el-table-column
          prop="auditDesc"
          label="审核意见"
          align="center"
          min-width="90px"
      >
        <template slot-scope="scope">
          <el-tooltip placement="top" effect="light" >
            <div slot="content" style="width:500px;height: 300px;
              overflow-y: auto;
              border: 1px solid #DCDFE6;
              padding: 8px 10px;
              border-radius: 4px;
              white-space: pre-wrap;" v-html="scope.row.auditDesc">
            </div>
            <span style="color: red">{{
                scope.row.auditDesc  && scope.row.auditDesc .length > 8 ? scope.row.auditDesc .slice(0, 8)+'...' : scope.row.auditDesc  || ''
              }}
            </span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column
          prop="auditDesc"
          label="解析意见"
          align="center"
          min-width="90px"
          v-if="userRole=='2'"
      >
        <template slot-scope="scope">
          <el-tooltip placement="top" effect="light" >
            <div slot="content" style="width:900px;height: 350px;
              overflow-y: auto;
              border: 1px solid #DCDFE6;
              padding: 8px 10px;
              border-radius: 4px;
              white-space: pre-wrap;" v-if="userRole=='2'" v-html="scope.row.parseDesc">
              <!--<template v-if="scope.row.parseDesc  !== '文件过大，请下载后查看'">
                <el-input type="textarea" readonly="true" show-word-limit :rows="20" v-model="scope.row.parseDesc"></el-input>
              </template>
              <template v-else>
                文件过大，请下载后查看 &nbsp;&nbsp;&nbsp;&nbsp;
                <el-button type="text" @click="fileDownTxt(scope.row.channelId)">点击下载</el-button>
              </template>-->
            </div>
            <span style="color: red">{{
                scope.row.parseDesc  && scope.row.parseDesc .length > 8 ? scope.row.parseDesc .slice(0, 8)+'...' : scope.row.parseDesc  || ''
              }}
            </span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column
          prop="existDesc"
          label="备注"
          align="center"
          min-width="70px"
          v-if="userRole==='2'"
      >
      </el-table-column>
      <el-table-column
          prop="publicityDate"
          align="center"
          min-width="75px"
          label="公示日期" v-if="userRole==='1' || userRole==='3'">
      </el-table-column>
      <el-table-column
          prop="joinDate"
          align="center"
          min-width="75px"
          label="挂网日期" v-if="userRole==='1' || userRole==='3'">
      </el-table-column>
      <el-table-column
          prop="exitDate"
          align="center"
          min-width="75px"
          label="退出日期" v-if="userRole==='1' || userRole==='3'">
      </el-table-column>
      <el-table-column
          prop="other"
          align="center"
          min-width="70px"
          label="其他信息">
        <template slot-scope="scope">
          <el-tooltip placement="top" effect="light">
            <div slot="content" style="width: 500px; height:300px; overflow-y: auto;white-space: normal; word-wrap: break-word; word-break: break-all;"
                 v-html="scope.row.otherInfo">
            </div>
            <span>其他信息</span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column
          prop="file_list"
          align="center"
          min-width="70px"
          label="附件预览">
        <template slot-scope="scope">
          <el-tooltip placement="top" effect="light">
            <div slot="content" style="width: 600px; height:300px; overflow-y: auto; white-space: normal; word-wrap: break-word; word-break: break-all;" >
              <div v-for="(file, index) in scope.row.file_list" :key="`file-${scope.row.id}-${index}`">
<!--                <el-button @click.native.prevent="previewPdf(scope,file)" type="text" size="small" >{{ file.fileAliasName }} </el-button>-->
                <el-button
                    @click.native.prevent="file.suffix === 'pdf' ? previewFile(file) : downloadFile(file)"
                    type="text"
                    size="small"
                >{{ file.fileAliasName }}</el-button>
              </div>
            </div>
            <span v-if="scope.row.file_list.length>0">预览</span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column
          prop="operator"
          min-width="115px"
          label="操作" align="center">
        <template slot-scope="scope">
          <div v-if="scope.row.level==='0'">
            <div v-for="(data, index) in scope.row.workFlowListUpdate" :key="`update-${scope.row.id}-${index}`">
              <el-button @click.native.prevent="operator(data)" type="text" size="small" v-if="data.wfType==='1'">渠道申报修改</el-button>
              <el-button @click.native.prevent="operator(data)" type="text" size="small" v-else-if="data.wfType==='2'">新增商户/门店修改</el-button>
              <el-button @click.native.prevent="operator(data)" type="text" size="small" v-else-if="data.wfType==='4'">修改商户/门店修改</el-button>
              <el-button @click.native.prevent="operator(data)" type="text" size="small" v-else-if="data.wfType==='3'">退出商户/门店修改</el-button>
              <!-- <el-button @click.native.prevent="operator(data)" type="text" size="small" v-else-if="data.wfType==='5'">退出渠道修改</el-button> -->
            </div>
            <div v-for="(data, index) in scope.row.workFlowListDetail" :key="`detail-${scope.row.id}-${index}`">
              <el-button @click.native.prevent="operator(data)" type="text" size="small" v-if="data.wfType==='1'">渠道申报查看</el-button>
              <el-button @click.native.prevent="operator(data)" type="text" size="small" v-else-if="data.wfType==='2'">新增商户/门店查看</el-button>
              <el-button @click.native.prevent="operator(data)" type="text" size="small" v-else-if="data.wfType==='4'">修改商户/门店查看</el-button>
              <el-button @click.native.prevent="operator(data)" type="text" size="small" v-else-if="data.wfType==='3'">退出商户/门店查看</el-button>
              <!-- <el-button @click.native.prevent="operator(data)" type="text" size="small" v-else-if="data.wfType==='5'">退出渠道查看</el-button> -->
            </div>
          </div>
          <el-button @click.native.prevent="approve(scope.row)" type="text" size="small"
                     v-if="userRole==='2' && scope.row.level==='1' && (scope.row.auditState.indexOf('1')!=-1)">审批</el-button>
          <div v-if="scope.row.NewAndHis!=null && (scope.row.wfType==='4' || scope.row.data_type === '4') && (scope.row.level==='1' || scope.row.level==='2')">
          <el-tooltip placement="top" effect="light">
            <div slot="content" style="width: 500px; height:300px; overflow-y: auto;white-space: normal; word-wrap: break-word; word-break: break-all;"
                 v-html="scope.row.NewAndHis">
            </div>
            <span style="color:#409EFF" size="small">数据对比</span>
          </el-tooltip>
          </div>
        </template>
      </el-table-column>
    </el-table>
    </div>
    <el-dialog
        title="渠道/商户/门店审批"
        :visible.sync="auditDialogVisible"
        width="60%"
        :close-on-click-modal="false"
    >
      <el-form  label-width="120px" >
        <el-row>
          <el-col :span="24">
            <el-form-item label="审批意见:" prop="technicalPerson">
              <el-input type="textarea" :rows="20" v-model="auditDesc" ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <div class="flex-item" style="text-align: center">
          <el-button size="small" type="primary" @click="agree(3)" v-if="userRole==='2'">通过</el-button>
          <el-button size="small" type="primary" @click="agree(4)" v-if="userRole==='2'">不通过</el-button>
          <el-button size="small" type="primary" @click="agree(6)" v-if="userRole==='3'">通过</el-button>
          <el-button size="small" type="primary" @click="agree(7)" v-if="userRole==='3'">不通过</el-button>
          <el-button size="small" type="primary" @click="closeAudit()">关闭</el-button>
        </div>
      </el-form>
    </el-dialog>
    <el-dialog
        title="批量公示"
        :visible.sync="dialogPublicityVisible"
        width="30%"
        :close-on-click-modal="false"
    >
    <el-form label-width="150px">
        <el-row>
          <el-col :span="24">
            <el-form-item label="公示日期:" prop="publicityDate">
              <el-date-picker
                  v-model="publicityDate"
                  style="width:100%"
                  value-format = "yyyy-MM-dd"
                  placeholder="选择日期">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <br/>
        <div class="flex-item" style="text-align: center">
          <el-button size="small" type="primary" @click="submitPublicity()">提交</el-button>
          <el-button size="small" type="primary" @click="closePublicity()">关闭</el-button>
        </div>
      </el-form>
    </el-dialog>
    <el-dialog
        title="批量外网通知/正式实施"
        :visible.sync="dialogFormVisible"
        width="30%"
        :close-on-click-modal="false"
    >
      <el-form  label-width="100px" >
        <el-row>
          <el-col :span="24">
            <el-form-item label="通知日期:" prop="joinOrExitDate">
              <el-date-picker
                  v-model="joinOrExitDate"
                  style="width:100%"
                  value-format = "yyyy-MM-dd"
                  placeholder="选择日期">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <div class="flex-item" style="text-align: center">
          <el-button size="small" type="primary" @click="saveJoinOrExitDate('1')">设置通知时间</el-button>
<!--          <el-button size="small" type="primary" @click="saveJoinOrExitDate('2')">设置退出时间</el-button>-->
          <el-button size="small" type="primary" @click="setJoinOrExitDate('1')">关闭</el-button>
        </div>
      </el-form>
    </el-dialog>
    <el-dialog
        title="请输入导出文件名字"
        :visible.sync="dialogExportVisible"
        width="30%"
        :close-on-click-modal="false"
    >
      <el-form  label-width="150px" >
        <el-row>
          <el-col :span="24">
            <el-input type="textarea" :rows="2" v-model="exportFileName"></el-input>
          </el-col>
        </el-row>
        <br/>
        <div class="flex-item" style="text-align: center">
          <el-button v-if="this.exportFlag=='4'" size="small" type="primary" @click="expZip()">导出</el-button>
          <el-button v-else size="small" type="primary" @click="submitExport()">导出</el-button>
          <el-button size="small" type="primary" @click="closeExport()">关闭</el-button>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import {
  getWorkflowList,
  getMerchantListByChannelId,
  getStoreListByMerchantId,
  template,
  fileParse,
  queryMerchantByTyc,
  auditWorkflow,
  saveWorkflowInfo,
  exportExcel,
  expZip,
  getChannelNameList,
  previewPdfFile,
  setJoinOrExitDate,
  publicity,
  getTerm,
  preview,
  auditCheck
} from "@/api/system/linXuanChannel/linXuanChannel";
import { setJoinDate } from "@/api/system/workflow/workflow";
import * as util from "@/assets/js/util";
import axios from 'axios';
import {SYS_APi_SCREENING_URL} from '@/utils/globals';
import { streamDownload } from '@/utils/download';

export default {
  name: "userList",
  data() {
    return {
      selection:'selection',
      userRole:'',
      operateFlag:'',
      isShowCDbut:true,
      isShowMerchantBut:false,
      title:'',
      flag: '',
      saleModel:'',
      wfType:'',
      isExistChannel: true,
      dialogFormVisible:false,
      auditDialogVisible:false,
      dialogPublicityVisible:false,
      dialogExportVisible:false,
      joinOrExitDate:'',
      multipleSelection:[],
      channelList:[],
      saleModels: [],
      auditList: [],
      load: false,
      tableLoading: false,
      currentPage: 1,
      pageSize: 20,
      total: 0,
      merchantCurrentPage: 1,
      merchantPageSize: 20,
      merchantTotal: 0,
      storeCurrentPage: 1,
      storePageSize: 20,
      storeTotal: 0,
      tableList: [],
      searchForm: {auditState:''},
      tableData: [],
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      auditDesc:'',
      publicityDate:'',
      auditData:null,
      exportFileName:'',
      exportFlag:'',
      term:{
        isInRange:false,
        info:''
      },
      scrollHandler: null,
      currChannelNode:null,
      currMerchantNode:null,
      currNode:null,
      isScrollLoadData:true,
      isLoadMerchantData:false,
      isLoadStoreData:false,
      tableHeight:"550px",
      scrollLock:true,
    };
  },
  created(){
    this.setTableHeigt();
    this.userRole=util.session("userRole").userRole;
    if(this.userRole=="2" || this.userRole=="3"){
      this.isShowCDbut=false;
    }
    if(this.userRole=="2"){
      this.selection="selection";
    }
    //this.userRole="2";
  },
  mounted() {
    window.fileDownTxt = this.fileDownTxt;
    this.bindTableScroll();
    this.initAuditStateList();
    this.getTableList();
    if (this.userRole === '1'){
        this.findTerm();
    } else {
      this.getChannelNameList();
    }
  },
  beforeDestroy() {
    this.unbindTableScroll();
    delete window.fileDownTxt;
  },
  methods: {
    setTableHeigt(){
      if (typeof window !== 'undefined') {
        if (window.innerHeight) {
          this.tableHeight = Math.round(window.innerHeight * 0.65)+"px";
        } else {
          let clientHeight = document.documentElement.clientHeight;
          this.tableHeight = Math.round(clientHeight * 0.65)+"px";
        }
      } else {
        this.tableHeight = "550px";
      }
    },
    bindTableScroll() {//绑定表格滚动事件
      var tableRoot = this.$refs.multipleTable && this.$refs.multipleTable.$el;
      if (!tableRoot) return;
      var scrollBox = tableRoot.querySelector(".el-table__body-wrapper"); // ElementUI表格内置的滚动容器
      if (!scrollBox) return;
      this.scrollHandler = this.handleTableScroll;
      scrollBox.addEventListener("scroll", this.scrollHandler);
    },
    unbindTableScroll() {
      var tableRoot = this.$refs.multipleTable && this.$refs.multipleTable.$el;
      if (!tableRoot) return;
      const scrollBox = tableRoot.querySelector(".el-table__body-wrapper");
      if (scrollBox && this.scrollHandler) {
        scrollBox.removeEventListener("scroll", this.scrollHandler);
        this.scrollHandler = null;
      }
    },
    handleTableScroll(e) {
      this.$nextTick(() => {
      //if(!this.scrollLock){
      //  return;
     // }
      //this.scrollLock = false;
      setTimeout(() => {
        const {
          scrollTop,//纵向滚动距离
          scrollLeft,//横向滚动距离
          scrollHeight,//滚动内容的总高度
          clientHeight // 滚动容器的可视高度
        } = e.target;
        let totalRows = 0;//渲染总记录行数
        let lastMerchantPos = 0;//当前渠道下滑动商户最后一条记录位置
        let lastStorePos = 0;//当前商户下滑动最后一条门店记录位置
        for(let i=0;i<this.tableData.length;i++) {
          totalRows++;
          if(this.currChannelNode != null && this.tableData[i].channelId===this.currChannelNode.channelId) {
            if (this.tableData[i].children) {
              let merchantList = this.tableData[i].children;
              lastMerchantPos = totalRows + merchantList.length;
              for (let j = 0; j < merchantList.length; j++) {
                totalRows++;
                if (this.currMerchantNode != null && merchantList[j].merchantId === this.currMerchantNode.merchantId) {
                  if (merchantList[j].children) {
                    let storeList = merchantList[j].children;
                    lastStorePos = totalRows + storeList.length;
                    lastMerchantPos += storeList.length;
                    totalRows += storeList.length;
                  }
                }
              }
            }
          }
        }
        //判断是否滚动到当前选中已加载数据底部
        if(this.currMerchantNode != null && this.isLoadStoreData){
          let avgHeight = scrollHeight/totalRows;
          let dataHeight = avgHeight*lastStorePos;
          const isScrollToBottom = scrollTop+clientHeight+10 >= dataHeight;
          /*console.log("----------------------------------------------");
          console.log("滚动加载当前商户门店：this.currMerchantNode="+this.currMerchantNode);
          console.log("滚动加载门店：totalRows="+totalRows+",lastStorePos="+lastStorePos);
          console.log("滚动加载门店：scrollTop="+scrollTop+",clientHeight="+clientHeight+",dataHeight="+dataHeight+",scrollHeight="+scrollHeight+",avgHeight="+avgHeight);
          console.log("滚动加载门店：isScrollToBottom="+isScrollToBottom);
          console.log("滚动加载门店：this.isLoadStoreData="+this.isLoadStoreData);*/
          if (isScrollToBottom) {
            this.getStoreList();
          }
        }
        if(this.currChannelNode != null && this.isLoadMerchantData){

          let avgHeight = scrollHeight/totalRows;
          let dataHeight = avgHeight*lastMerchantPos;
          const isScrollToBottom = scrollTop+clientHeight+10 >= dataHeight;
          /*console.log("----------------------------------------------");
          console.log("滚动加载当前渠道商户：this.currChannelNode="+this.currChannelNode);
          console.log("滚动加载商户：totalRows="+totalRows+",lastMerchantPos="+lastMerchantPos);
          console.log("滚动加载商户：scrollTop="+scrollTop+",clientHeight="+clientHeight+",dataHeight="+dataHeight+",scrollHeight="+scrollHeight+",avgHeight="+avgHeight);
          console.log("滚动加载商户：isScrollToBottom="+isScrollToBottom);
          console.log("滚动加载商户：this.isLoadMerchantData="+this.isLoadMerchantData);*/
          if (isScrollToBottom) {
            this.getMerchantList();
          }
        }
        //this.scrollLock = true;
      }, 200);
      });
    },
    getMerchantList(){
      if(this.merchantTotal <= this.merchantPageSize){
        this.scrollLock = false;
        this.isLoadMerchantData=false;
        return;
      }
      let count = this.merchantCurrentPage*this.merchantPageSize;
      if(count>=this.merchantTotal){
        this.$message.success("当前渠道没有更多商户了");
        //this.currChannelNode=null;
        this.isLoadMerchantData=false;
        return;
      }
      this.merchantCurrentPage=(this.merchantCurrentPage+1);
      this.tableLoading = true;
      this.isLoadMerchantData=false;
      getMerchantListByChannelId({
        keyword:this.searchForm.keyword,
        wfType: this.searchForm.wfType,
        channelId: this.currChannelNode.channelId,
        flowId: this.currChannelNode.parentId,
        auditState: this.searchForm.auditState,
        pageNo: this.merchantCurrentPage,
        pageSize: this.merchantPageSize
      }).then((res) => {
        this.tableLoading = false;
        this.isLoadMerchantData=true;
        if (res.code==200) {
          let mlist = [];
          if(res.data != null) {
            mlist=res.data.resultList;
            const pageOffset = (this.merchantCurrentPage - 1) * this.merchantPageSize;
            mlist.forEach((item, idx) => {
              item.checked = this.currChannelNode.checked;
              item.indeterminate = false;
              item.saleModel = this.currChannelNode.saleModel;
              item.rowIndex = pageOffset + idx + 1;  // 该商户在channel中的全局序号
              this.currChannelNode.children.push(item);
            });
          }
        } else {
          this.$message.error(res.message);
        }
      });
    },
    getStoreList() {
      if(this.storeTotal <= this.storePageSize){
        this.isLoadMerchantData = true;
        this.isLoadStoreData=false;
        return;
      }
      let count = this.storeCurrentPage* this.storePageSize;
      if (count >= this.storeTotal) {
        this.isLoadMerchantData = true;
        this.$message.error("当前商户没有更多门店了");
        //this.currMerchantNode=null;
        this.isLoadStoreData=false;
        return;
      }
      this.tableLoading = true;
      this.isLoadStoreData = false;
      this.storeCurrentPage=(this.storeCurrentPage+1);
      getStoreListByMerchantId({
        wfType: this.searchForm.wfType,
        keyword: this.searchForm.keyword,
        merchantId: this.currMerchantNode.merchantId,
        channelId: this.currMerchantNode.channelId,
        flowId: this.currMerchantNode.flowId,
        auditState: this.searchForm.auditState,
        pageNo: this.storeCurrentPage,
        pageSize: this.storePageSize
      }).then((res) => {
        this.tableLoading = false;
        this.isLoadStoreData=true;
        if (res.code==200) {
          let childs = [];
          if (res.data.resultList != null) {
            childs = res.data.resultList;
            const pageOffset = (this.storeCurrentPage - 1) * this.storePageSize;
            childs.forEach((item, idx) => {
              item.checked = this.currMerchantNode.checked;
              item.indeterminate = false;
              item.saleModel = this.currMerchantNode.saleModel;
              item.rowIndex = pageOffset + idx + 1;  // 该门店在merchant中的全局序号
              this.currMerchantNode.children.push(item);
            });
          }
        } else {
          this.$message.error(res.message);
        }
      });
    },
    handleExpandChange(row, expanded) {
      const currentNodeId = row.id;
      const table = this.$refs.multipleTable;
      const treeData = table.store.states.treeData;
      const currentNode = treeData[currentNodeId];
      if (!currentNode) return;
      if (!expanded) {//关闭节点：清空当前节点+所有子节点缓存
        if(row.children){
          row.children=[];//关闭节点清除子节点数据
        }
        if (row.level=="0") {
          this.currChannelNode=null;
          this.currMerchantNode=null;
          this.clearFirstLevelAllChildren(currentNodeId, treeData);
        } else {
          this.currMerchantNode=null;
          this.clearTreeNode(currentNode, treeData);
        }
        return;
      }
      if (row.level=="0") {//展开一级节点
        this.handleFirstLevelExpand(currentNodeId, treeData);
      } else {//展开二级节点
        this.handleSecondLevelExpand(currentNodeId, treeData);
      }
    },
    clearFirstLevelAllChildren(firstNodeId, treeData) {//关闭一级节点时，清空所有二级+三级缓存
      const firstNode = treeData[firstNodeId];
      if (!firstNode || !firstNode.children || firstNode.children.length === 0) {
        //无二级节点，直接重置一级节点
        this.clearTreeNode(firstNode, treeData);
        return;
      }
      //逐个深度清理二级+三级
      firstNode.children.forEach(secondNodeId => {
        const secondNode = treeData[secondNodeId];
        if (secondNode) {
          this.clearTreeNode(secondNode, treeData);
        }
      });
      //重置一级节点自身
      this.clearTreeNode(firstNode, treeData);
    },
    handleFirstLevelExpand(currentFirstId, treeData) {
      Object.keys(treeData).forEach(nodeId => {
        const node = treeData[nodeId];
        const isOtherFirstLevel = (nodeId !== currentFirstId) && (node.level === 0) && node.expanded;
        if (isOtherFirstLevel) {
          node.expanded = false;
          this.clearFirstLevelAllChildren(nodeId, treeData);//清空缓存
        }
      });
    },
    handleSecondLevelExpand(currentSecondId, treeData) {
      let parentFirstNode = null;
      let parentFirstId = "";
      for (const nodeId of Object.keys(treeData)) {
        const node = treeData[nodeId];
        if (node.level === 0 && node.children && node.children.includes(currentSecondId)) {
          parentFirstNode = node;
          parentFirstId = nodeId;
          break;
        }
      }
      if (!parentFirstNode || !parentFirstNode.children) return;
      parentFirstNode.children.forEach(childId => {
        if (childId !== currentSecondId && treeData[childId]) {
          const otherSecondNode = treeData[childId];
          if (otherSecondNode.expanded) {
            otherSecondNode.expanded = false;
            this.clearTreeNode(otherSecondNode, treeData);//清空缓存
          }
        }
      });
    },
    clearTreeNode(node, treeData) {
      //console.log("treeData="+JSON.stringify(treeData))
      if (!node) return;
      node.loaded = false;//懒加载完成标识
      node.loading = false;//懒加载中状态
      node.expanded = false;//展开状态
      node.children = [];
      if (node.childNodes) node.childNodes = [];
      if (node._children) node._children = [];
      node.display = true;
      const currentNodeId = Object.keys(treeData).find(id => treeData[id] === node);
      if (!currentNodeId) return;
      Object.keys(treeData).forEach(childId => {
        const childNode = treeData[childId];
        const isChildNode = (childNode.parent === node) ||
            (childNode.parentId === currentNodeId) ||
            (childNode.parent && childNode.parent.id === currentNodeId);
        if (isChildNode) {
          this.clearTreeNode(childNode, treeData);
        }
      });
    },
    initAuditStateList(){
      if(this.userRole==='1'){//遴选申报
        this.title='渠道申报';
        this.auditList=[
          {value: '0', label: '等待提交'},
          {value: '1', label: '等待初审'},
          // {value: '2', label: '初审部分通过/部分终审中'},
          {value: '3', label: '初审通过'},
          {value: '4', label: '初审不通过'},
          // {value: '5', label: '终审部分通过'},
          {value: '6', label: '终审通过'},
          {value: '7', label: '终审不通过'},
          {value: '10', label: '暂未公示'},
          {value: '8', label: '已经公示'},
          {value: '9', label: '已挂外网通知'},
          {value: '11', label: '暂未外网通知'}
        ];
      }else if(this.userRole==='2'){//遴选初审
        this.title='渠道审批';
        this.searchForm.auditState="1";
        this.auditList=[
          {value: '1', label: '等待初审'},
          // {value: '2', label: '初审部分通过/部分终审中'},
          {value: '3', label: '初审通过'},
          {value: '4', label: '初审不通过'},
        ];
      }else if(this.userRole==='3') {//遴选终审
        this.title='审批/查看/导出';
        this.searchForm.auditState="3";
        this.auditList=[
          // {value: '2', label: '初审部分通过/部分终审中'},
          {value: '3', label: '初审通过'},
          // {value: '5', label: '终审部分通过'},
          {value: '6', label: '终审通过'},
          {value: '7', label: '终审不通过'},
          {value: '10', label: '暂未公示'},
          {value: '8', label: '已经公示'},
          {value: '9', label: '已挂外网通知'},
          {value: '11', label: '暂未外网通知'}
        ];
      }
    },
    getFirstLevelIndex(row){
      if(row.level==='0'){
        // 一级渠道：直接取在 tableData 中的位置
        for(let i=0;i<this.tableData.length;i++) {
          if(row.flowId==this.tableData[i].flowId){
            return i+1;
          }
        }
      }else if(row.level==='1'){
        // 二级商户：用预先计算好的 rowIndex
        const channelIdx = this.getChannelIndexByMerchant(row);
        if(channelIdx===-1) return 1;
        return (channelIdx+1) + "-" + (row.rowIndex||1);
      }else if(row.level==='2'){
        // 三级门店：用预先计算好的 rowIndex
        const channelIdx = this.getChannelIndexByStore(row);
        const merchantIdx = this.getMerchantIndexByStore(row, channelIdx);
        if(channelIdx===-1) return '1-1';
        return (channelIdx+1) + "-" + (merchantIdx+1) + "-" + (row.rowIndex||1);
      }
      return 1;
    },
    getChannelIndexByMerchant(row){
      for(let i=0;i<this.tableData.length;i++){
        if(this.tableData[i].flowId === row.flowId){
          return i;
        }
      }
      return -1;
    },
    getChannelIndexByStore(row){
      for(let i=0;i<this.tableData.length;i++){
        if(this.tableData[i].flowId === row.flowId){
          return i;
        }
      }
      return -1;
    },
    getMerchantIndexByStore(row, channelIdx){
      const channel = this.tableData[channelIdx];
      if(!channel || !channel.children) return 0;
      for(let j=0;j<channel.children.length;j++){
        if(channel.children[j].merchantId === row.merchantId){
          // 用商户的全局 rowIndex 而不是数组位置
          return (channel.children[j].rowIndex || j+1) - 1; // 转为0-based
        }
      }
      return 0;
    },
    findTerm(){
      getTerm({
      }).then((res) => {
        if (res.code==200) {
          if(res.data!=null){
            this.term=res.data;
          }
        } else {
          this.$message.error(res.message);
        }
      });
    },
    submitPublicity(){
      const loading = this.$loading({
        lock: true,
        text: '提交中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      let data=this.getSelectedIds();
      publicity({
        channleIds:data.channleIds,
        auditState:"8",
        date:this.publicityDate
      }).then((res) => {
        if (res.code == 200) {
          this.$message({
            type: "success",
            message: "提交成功!",
          });
          this.dialogPublicityVisible=false;
          this.onSearch();
        } else {
          this.$message.error(res.message);
        }
        loading.close();
      });
    },
    closeAudit(){
      this.auditDialogVisible=false;
    },
    closePublicity(){
      this.dialogPublicityVisible=false;
    },
    getChannelNameList(){
      getChannelNameList({
        wfType: this.wfType,
        auditState: this.searchForm.auditState,
        saleModel: this.saleModel,
        keyword: this.searchForm.keyword
      }).then((res) => {
        if (res.code==200) {
          this.channelList=res.data;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    setChannelScrollTop(){
      this.$nextTick(() => {
        setTimeout(() => {
          let totalRows = 0;//渲染总记录行数
          let channelPos = 0;//当前渠道位置
          for(let i=0;i<this.tableData.length;i++) {
            totalRows++;
            if(this.currChannelNode != null && this.tableData[i].channelId===this.currChannelNode.channelId){
              channelPos = i+1;
              if(this.tableData[i].children) {
                totalRows+=this.tableData[i].children.length;
              }
            }
          }
          const wrapper = this.$refs.multipleTable.$el.querySelector('.el-table__body-wrapper');
          if (wrapper) {
            const scrollHeight = wrapper.scrollHeight;
            const clientHeight = wrapper.clientHeight;
            const availableScroll = scrollHeight - clientHeight;
            let avgHeight = wrapper.scrollHeight/totalRows;
            if (availableScroll <= 0) {
              wrapper.scrollTop = 0;
              return;
            }
            /*console.log("++++++++++++++++++++++++++");
            console.log("setChannelScrollTop：channelPos="+channelPos);
            console.log("setChannelScrollTop：scrollHeight="+scrollHeight+",clientHeight="+clientHeight);
            console.log("setChannelScrollTop：availableScroll="+availableScroll);
            console.log("setChannelScrollTop：avgHeight="+avgHeight);*/
            let scrollTop = 0;
            if(channelPos>1) {
              channelPos = channelPos-1;
              scrollTop = (channelPos / totalRows) * availableScroll;
              scrollTop = scrollTop + avgHeight - 10;
              scrollTop = Math.max(0, Math.min(scrollTop, availableScroll));
            }
            //console.log("setChannelScrollTop：scrollTop="+scrollTop);
            wrapper.scrollTop = Math.round(scrollTop);
          }
        }, 200);
      })
    },
    setMerchantScrollTop(){
      this.$nextTick(() => {
        setTimeout(() => {
          let totalRows = 0;//渲染总记录行数
          let merchantPos = 0;//当前商户位置
          for(let i=0;i<this.tableData.length;i++) {
            totalRows++;
            if(this.currChannelNode != null && this.tableData[i].channelId===this.currChannelNode.channelId) {
              if (this.tableData[i].children) {
                let merchantList = this.tableData[i].children;
                for (let j = 0; j < merchantList.length; j++) {
                  totalRows++;
                  if (this.currMerchantNode != null && merchantList[j].merchantId === this.currMerchantNode.merchantId) {
                    merchantPos = totalRows;
                    if(merchantList[j].children){
                      totalRows += merchantList[j].children.length;
                    }
                  }
                }
              }
            }
          }
          const wrapper = this.$refs.multipleTable.$el.querySelector('.el-table__body-wrapper');
          if (wrapper) {
            const scrollHeight = wrapper.scrollHeight;
            const clientHeight = wrapper.clientHeight;
            const availableScroll = scrollHeight - clientHeight;
            let avgHeight = wrapper.scrollHeight/totalRows;
            if (availableScroll <= 0) {
              wrapper.scrollTop = 0;
              return;
            }
            /*console.log("++++++++++++++++++++++++++");
            console.log("setMerchantScrollTop：merchantPos="+merchantPos);
            console.log("setMerchantScrollTop：scrollHeight="+scrollHeight+",clientHeight="+clientHeight);
            console.log("setMerchantScrollTop：availableScroll="+availableScroll);
            console.log("setMerchantScrollTop：avgHeight="+avgHeight);*/
            let scrollTop = 0;
            if(merchantPos>1) {
              merchantPos = merchantPos-1;
              scrollTop = (merchantPos / totalRows) * availableScroll;
              scrollTop = scrollTop + avgHeight - 10;
              scrollTop = Math.max(0, Math.min(scrollTop, availableScroll));
            }
            //console.log("setMerchantScrollTop：scrollTop="+scrollTop);
            wrapper.scrollTop = Math.round(scrollTop);
          }
        }, 200);
      })
    },
    loadNode(node,treeNode,resolve) {
      try {
        if(this.userRole==="2" && this.searchForm.auditState==="1"){
          var list = String(node.auditState || '').split(',');
          if (list.includes('1')) {
            this.$message.error("有待初审文件需要解析，请先解析文件！")
            return false;
          }
        }
        if(node.level=='0'){
          this.merchantCurrentPage=1;
          this.merchantTotal=0;
          this.currChannelNode=node;
          // 先清空子节点缓存，避免旧数据残留
          node.children=[];
          getMerchantListByChannelId({
            keyword:this.searchForm.keyword,
            wfType: this.searchForm.wfType,
            channelId: node.channelId,
            flowId: node.parentId,
            auditState: this.searchForm.auditState,
            pageNo: this.merchantCurrentPage,
            pageSize: this.merchantPageSize
          }).then((res) => {
            if (res.code==200) {
              let childs=[];
              if(res.data != null) {
                this.isLoadMerchantData=true;
                childs = res.data.resultList;
                this.merchantTotal=res.data.count;
                const pageOffset = (this.merchantCurrentPage - 1) * this.merchantPageSize;
                childs.forEach((item, idx) => {
                  item.checked = node.checked;
                  item.indeterminate = false;
                  item.saleModel=node.saleModel;
                  item.rowIndex = pageOffset + idx + 1;  // 该商户在channel中的全局序号
                });
              }
              node.children=childs;
              node.loaded=true;//标记懒加载完成
              resolve(childs);
              if(this.currChannelNode){
                this.setChannelScrollTop();
              }
            } else {
              this.$message.error(res.message);
            }
          });
        }else if(node.level=='1'){
          this.storeCurrentPage=1;
          this.storeTotal=0;
          this.currMerchantNode=node;
          // 先清空子节点缓存，避免旧数据残留
          node.children=[];
          getStoreListByMerchantId({
            wfType: this.searchForm.wfType,
            keyword:this.searchForm.keyword,
            merchantId: node.merchantId,
            flowId: node.flowId,
            channelId: node.channelId,
            auditState: this.searchForm.auditState,
            pageNo: this.storeCurrentPage,
            pageSize: this.storePageSize
          }).then((res) => {
            if (res.code==200) {
              let childs=[];
              if(res.data != null) {
                this.isLoadMerchantData = false;
                this.isLoadStoreData=true;
                childs = res.data.resultList;
                this.storeTotal=res.data.count;
                const pageOffset = (this.storeCurrentPage - 1) * this.storePageSize;
                childs.forEach((item, idx) => {
                  item.checked=node.checked;
                  item.indeterminate=false;
                  item.saleModel=node.saleModel;
                  item.rowIndex = pageOffset + idx + 1;  // 该门店在merchant中的全局序号
                });
              }
              node.children=childs;
              node.loaded=true;//标记懒加载完成
              resolve(childs);
              if(this.currMerchantNode){
                this.setMerchantScrollTop();
              }
            } else {
              this.$message.error(res.message);
            }
          });
        }
      } catch (error) {
        console.error("加载数据失败：", error);
        this.$message.error('加载数据失败');
      }
    },
    getSingleAuditData(data){
      let channleList=[];
      if(data.level=="1"){//商户
        let storeList=[];
        this.tableData.forEach(channel => {
          if(channel.children && channel.children.length>0){
            channel.children.forEach(merchent => {
              if(merchent.children && merchent.children.length>0){
                merchent.children.forEach(store => {
                  if(store.checked && store.merchantId==data.merchantId){
                    storeList.push({
                      id: store.getId()
                    });
                  }
                })
              }
            })
          }
        });
        let channelItem = {
          id: data.channelId,
          merchantList: [{id:data.id,flowId:data.flowId,storeList:storeList}]
        };
        channleList.push(channelItem);
      }else if(data.level=="2") {//门店
        let channelId="";
        this.tableData.forEach(channel => {
          if(channel.children && channel.children.length>0){
            channel.children.forEach(merchent => {
              if(merchent.merchantId==this.auditData.merchantId){
                channelId=merchent.channelId;
              }
            })
          }
        });
        let channelItem = {
          id: channelId,
          merchantList: [{id:data.merchanId,flowId:data.flowId,storeList:[{id:data.id}]}]
        };
        channleList.push(channelItem);
      }
      return channleList;
    },
    agree(auditState){
      let channelList=[];
      let auditType="";//1.单个商户审批，2.批量审批
      if(this.auditData!=null){
        channelList = this.getSingleAuditData(this.auditData);
        auditType="1";
      }else {
        auditType="2";
        let data = this.getSelectedLevelData();
        if (data.channelList.length == 0) {
          this.$message({
            message: '请选择记录！',
            type: 'warning'
          });
          return;
        }else{
          channelList = data.channelList;
        }
      }
      auditCheck({
        channelList:channelList,
        auditState:auditState,
        auditDesc:this.auditDesc,
        auditFlag:'1'
      }).then((res) => {
        let auditFlag="";
        if (res.message!="") {
          auditFlag="1";
        }else{
          auditFlag="0";
        }
        this.$confirm("确定要执行审批操作吗?", "提示", {
           confirmButtonText: "确定",
           cancelButtonText: "取消",
           type: "warning",
           dangerouslyUseHTMLString: true
         }).then(() => {
           const loading = this.$loading({
             lock: true,
             text: '提交中...',
             spinner: 'el-icon-loading',
             background: 'rgba(0, 0, 0, 0.7)'
           });
          auditWorkflow({
             channelList:channelList,
             auditState:auditState,
             auditDesc:this.auditDesc,
             auditFlag:auditFlag,
             auditType: auditType
           }).then((res) => {
             this.auditData=null;
             if (res.code == 200) {
               this.onSearch();
               this.$message({
                 type: "success",
                 message: res.data,
               });
               this.auditDialogVisible=false;
             } else {
               this.$message.error(res.message);
             }
             loading.close();
           });
          });
      });
    },
    getTableList() {
      this.tableLoading = true;
      getWorkflowList({
        keyword:this.searchForm.keyword,
        wfType: this.searchForm.wfType,
        wfState: this.searchForm.auditState,
        saleModel: this.searchForm.saleModel,
        channelName: this.searchForm.channelName,
        pageNo: 1,
        pageSize: 200
      }).then((res) => {
        this.tableLoading=false;
        if (res.code==200) {
          let data=res.data.resultList;
          if(this.userRole=='1' && data!= null && data.length>0){
            this.isShowCDbut=false;
          }
          if(data != null){
            data.forEach(item => {
              item.checked=false;
              item.indeterminate=false;
              item.children=[];
              item.loaded=false;
              item.loading=false;
              item.expanded=false;
              item._children=null;
              if(item.childNodes) item.childNodes=[];
              if(item.level=="0" && item.auditState.indexOf("6")!=-1){
                this.isShowMerchantBut=true;
              }
            });
          }
          this.tableData=data;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    getCheckboxDisabled(row){
      if ((this.userRole=='2' || this.userRole=='3') && row.level=='2') {
        return true;
      }else{
        return false;
      }
    },
    handleCheckChange(row, index) {
      this.checkChildren(row, row.checked);
      this.checkParent(this.tableData);
    },
    checkChildren(row, checked) {
      if (row.children && row.children.length>0) {
        row.children.forEach(child => {
          child.checked = checked;
          child.indeterminate = false;
          if(child.children && child.children.length>0){
            this.checkChildren(child, checked);
          }
        });
      }
    },
    checkParent(data) {
      for (let i=0;i<data.length;i++) {
        if(data[i].children && data[i].children.length>0) {//商户
          let isCheck = false;
          let merchants = data[i].children;
          for (let j = 0; j < merchants.length; j++) {
            isCheck = false;
            if(merchants[j].children && merchants[j].children.length>0){//门店
              let stores = merchants[j].children;
              for (let k = 0; k < stores.length; k++) {
                if (stores[k].checked) {
                  isCheck = true;
                  break;
                }
              }
            }else{
              if (merchants[j].checked) {
                isCheck = true;
              }
            }
            merchants[j].checked=isCheck;
            if(isCheck){
              break;
            }
          }
          data[i].checked=isCheck;
        }
      }
    },
    downloadTemplate() {
      const loading = this.$loading({
        lock: true,
        text: "正在下载...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      template({
        type:"0"
      }).then((res) => {
        loading.close();
        let blob = new Blob([res]);
        let url = window.URL.createObjectURL(blob); // 创建 url 并指向 blob
        let a = document.createElement("a");
        a.href = url;
        a.target = "_blank";
        a.rel = "noopener noreferrer";
        a.download = `遴选模板.zip`;
        a.click();
        window.URL.revokeObjectURL(url); // 释放该 url
        this.$message.success("下载成功");
      }).catch(error => {
        loading.close();
        this.$message.error("下载失败");
      });
    },
    onSearch() {
      this.tableData=[];
      this.currentPage = 1;
      this.isLoadMerchantData = false;
      this.isLoadStoreData = false;
      this.currMerchantNode = null;
      this.currChannelNode = null;
      this.getTableList();
    },
    channelDeclare() {
      if(this.userRole=="1" && this.term.isInRange==false){
        this.$message.error(this.term.info);
        return;
      }
      let flowId=null;
      this.$router.push({
        path: `/sys/linXuanChannel/channelIndex/1/1/all/ `
      });
    },
    operator(data){
      let operatorType = "";
      if(this.userRole=="2" || this.userRole=="3"){//初审、终审只能查看
        operatorType = "0";
      }else{
        operatorType = data.operator;
      }

      if(operatorType!="0"){
        if(this.userRole=="1" && this.term.isInRange==false){//集中申报期判断
          this.$message.error(this.term.info);
          return;
        }
      }
      let flowState = "";
      if(this.searchForm.auditState===''){
        flowState = "all";
      }else{
        flowState = this.searchForm.auditState;
      }
      if(this.userRole=='2'){
        if (data.wfType==="1" || data.wfType==="6"){
          this.$router.push({
            path: `/sys/linXuanChannel/channelView/${operatorType}/${data.wfType}/${flowState}/${data.flowId}`
          });
        }else if(data.wfType=="2" || data.wfType=="3" || data.wfType=="4"){
          this.$router.push({
            path: `/sys/linXuanChannel/merchantView/${operatorType}/${data.wfType}/${flowState}/${data.flowId}`
          });
        }
      } else {
        if (data.wfType==="1" || data.wfType==="6"){
          this.$router.push({
            path: `/sys/linXuanChannel/channelIndex/${operatorType}/${data.wfType}/${flowState}/${data.channelId}`
          });
        }else if(data.wfType=="2" || data.wfType=="3" || data.wfType=="4"){
          this.$router.push({
            path: `/sys/linXuanChannel/merchantIndex/${operatorType}/${data.wfType}/${flowState}/${data.channelId}`
          });
        }
      }
    },
    approve(row){
      this.auditData={};
      if(row.auditState=='1-0' ){
        this.$message.info("渠道/商户资料未解析和核对完毕，不能审批操作！");
        return;
      }
      this.auditData=row;
      this.auditDialogVisible=true;
    },
    batchApprove(){
      this.auditDesc = "";
      let data = this.getSelectedCheckbox();
      let message = "";
      for (const item of data) {
        if (this.userRole == '3' && item.auditState.indexOf('3') == -1) {
          message = "请选择初审通过的记录操作！";
          break;
        }
        if (this.userRole == '2' && item.auditState.indexOf('1-1') == -1 && item.auditState.indexOf('1-2') == -1) {
          message = "请选择文件解析完成或商户核对完毕的记录！";
          break;
        }
      }
      if(message != "") {
        this.$message({
          type: "error",
          message: message,
        });
        return;
      }
      this.auditDialogVisible = true;
    },
    batchPublicity(){
      let data = this.getSelectedCheckbox();
      let isPublicityDate=false;
      for (const item of data) {
        if((item.publicityDate===''||item.publicityDate===null)&&item.level==='0'&&item.auditState==='6'){
          isPublicityDate=true;
        }
      }
      if (isPublicityDate != true) {
        this.$message({
          type: "error",
          message: "数据选择错误",
        });
        return;
      }
      this.dialogPublicityVisible = true;
    },
    reset() {
      this.searchForm = {};
    },
    handleSizeChange(num) {
      this.pageSize = num;
      this.currentPage = 1;
      this.getTableList();
    },
    handleCurrentChange(num) {
      this.currentPage = num;
      this.getTableList();
    },
    handleSelectionChange(val) {
      if(val.length==0){
        this.tableData.forEach(item => {
          this.resetCheck(item,false);
        });
      }else{
        this.tableData.forEach(item => {
         this.resetCheck(item,true);
        });
      }
      this.multipleSelection = val;
    },
    resetCheck(item,checked) {
      item.checked = checked;
      item.indeterminate = false;
      if (item.children && Array.isArray(item.children) && item.children.length > 0) {
        item.children.forEach(child => this.resetCheck(child,checked));
      }
    },
    analysis(){
      if(this.multipleSelection.length<=0){
        this.$message('请选择要解析的记录');
      }else{
        this.$confirm("确定要解析吗?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "info",
        }).then(() => {
          const loading = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          });
          setTimeout(() => {
            this.$message({
              message: '操作成功！',
              type: 'success'
            });
            loading.close();
          }, 1000);
        });
      }
    },
    check(){
      if(this.multipleSelection.length<=0){
        this.$message('请选择要核验的记录');
      }else{
        this.$confirm("确定要核验吗?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "info",
        }).then(() => {
          const loading = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          });
          setTimeout(() => {
            this.$message({
              message: '操作成功！',
              type: 'success'
            });
            loading.close();
          }, 1000);
        });
      }
    },
    exportExcel(flag){
      this.dialogExportVisible=true;
      this.exportFileName="";
      this.exportFlag=flag;
    },
    closeExport(){
      this.dialogExportVisible=false;
    },
    expZip(){
      if(this.exportFileName==""){
        this.$message({
          message: '请输入下载文件名称！',
          type: 'success'
        });
        return;
      }
      const loading = this.$loading({
          lock: true,
          text: "正在下载...",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)"
        });
        expZip({exportFileName:this.exportFileName}).then((res) => {
        loading.close();
        this.dialogExportVisible=false;
        let blob = new Blob([res]);
        let url = window.URL.createObjectURL(blob); // 创建 url 并指向 blob
        let a = document.createElement("a");
        a.href = url;
        a.download = "提数.zip";
        a.click();
        window.URL.revokeObjectURL(url); // 释放该 url
        this.$message.success("导出成功");
      });  
    },
    submitExport(){
      if(this.exportFileName==""){
        this.$message({
          message: '请输入导出文件名称！',
          type: 'success'
        });
        return;
      }
      const loading = this.$loading({
          lock: true,
          text: "正在下载...",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)"
        });
      let channleIds="";
      let selectedData = this.getSelectedIds();
      if(selectedData!=undefined){
        channleIds = selectedData.channleIds;
      }
      if((selectedData==undefined || selectedData.channleIds=='') && this.userRole=='1'){
        channleIds=this.tableData[0].channelId;
      }
      /*this.multipleSelection.forEach(item => {
        if(item.level=='0'){//渠道
          if(channleIds==""){
            channleIds=item.channelId;
          }else{
            channleIds+=","+item.channelId;
          }
        }
      });*/
      exportExcel({
        channelId:channleIds,
        isHasStore:this.exportFlag,
        wfType:this.searchForm.wfType,
        auditState:this.searchForm.auditState,
        saleModel:this.searchForm.saleModel,
        channelName:this.searchForm.channelName,
        exportFileName:this.exportFileName
      }).then((res) => {
        loading.close();
        this.dialogExportVisible=false;
        let blob = new Blob([res]);
        let url = window.URL.createObjectURL(blob); // 创建 url 并指向 blob
        let a = document.createElement("a");
        a.href = url;
        a.download = this.exportFileName+".xlsx";
        a.click();
        window.URL.revokeObjectURL(url); // 释放该 url
        this.$message.success("导出成功");
      });
    },
    selectAuditStatus(value){
      this.searchForm.auditState=value;
      this.getChannelNameList();
    },
    selectSaleModel(value){
      this.saleModel=value;
      this.getChannelNameList();
    },
    selectWfType(value){
      this.wfType=value;
      this.getChannelNameList();
    },
    changekeyword(value){
      this.searchForm.keyword=value;
      this.getChannelNameList();
    },
    fileParse() {
      this.$confirm("确定要解析所有未解析的压缩文件?", "提示", {
        confirmButtonText: "确定解析",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$message({
            type: "success",
            message: "解析压缩文件后台进行中!",
        });
        // const loading = this.$loading({
        //     lock: true,
        //     text: '解析压缩文件中，请稍后',
        //     spinner: 'el-icon-loading',
        //     background: 'rgba(0, 0, 0, 0.7)'
        //   });
        let data=this.getSelectedIds();
        console.log(data.workFlowIds);
        if(data.workFlowIds==null||data.workFlowIds==""){
          return;
        }
        fileParse({
          data:data
        }).then((res) => {
          // loading.close();
          if (res.code == 200) {
            this.onSearch();
            this.$message({
                type: "success",
                message: res.data,
            });
          } else {
              this.$message.error(res.message);
          }
        });
      });
     },
     queryMerchantByTyc() {
      if (this.multipleSelection.length === 0) {
        this.$confirm("当前未选中数据，确定要进行商户数据全量校验?", "全量校验提示", {
          confirmButtonText: "确定全量校验",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.$message({
              type: "success",
              message: "全量商户数据校验后台进行中!",
          });
          queryMerchantByTyc({channelIds: null}).then((res) => {
            if (res.code == 200) {
              this.onSearch();
              this.$message({
                  type: "success",
                  message: "全量商户数据校验完成!",
              });
            } else {
                this.$message.error(res.message);
            }
          });
        });
      } else {
        this.$confirm("确定对选中的数据进行商户校验?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          var channleIds = [];
          this.multipleSelection.forEach(item => {
            channleIds.push(item.channelId);
          });
          this.$message({
              type: "success",
              message: "商户数据校验后台进行中!",
          });
          queryMerchantByTyc({channelIds: channleIds.join(',')}).then((res) => {
            if (res.code == 200) {
              this.onSearch();
              this.$message({
                  type: "success",
                  message: "商户数据校验完成!",
              });
            } else {
                this.$message.error(res.message);
            }
          });
        });
      }
     },
    previewFile(file) {
      if (!file.filePath) return;
      const loading = this.$loading({
        lock: true,
        text: '加载文件中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      const token = this.$store.state.token;
      if (!token) {
        this.$message.error('未登录，无法预览');
        loading.close();
        return;
      }
      const apiUrl = SYS_APi_SCREENING_URL + '/filedown/bigFileDownLoad';
      const params = new URLSearchParams();
      params.append('url', file.filePath);
      params.append('name', file.fileName);
      const finalUrl = `${apiUrl}?${params.toString()}`;
      fetch(finalUrl, { headers: { 'token': token } })
          .then(res => {
            if (!res.ok) throw new Error(`服务器错误: ${res.status}`);
            return res.blob();
          })
          .then(blob => {
            loading.close();
            const blobUrl = window.URL.createObjectURL(new Blob([blob], { type: 'application/pdf' }));
            window.open(blobUrl, '_blank');
          })
          .catch(() => {
            loading.close();
            this.$message.error('预览失败');
          });
    },
    downloadFile(file) {
      const loading = this.$loading({
        lock: true,
        text: '正在下载...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      const apiUrl = SYS_APi_SCREENING_URL + '/filedown/bigFileDownLoad';
      const params = new URLSearchParams();
      params.append('url', file.filePath || '');
      params.append('name', file.fileName || 'download');
      const finalUrl = `${apiUrl}?${params.toString()}`;
      const token = this.$store.state.token;
      if (!token) {
        this.$message.error('未登录，无法下载');
        loading.close();
        return;
      }
      streamDownload(finalUrl, {
        token,
        filename: file.fileName || 'download',
        onProgress: (percent, downloadedMB) => {
          if (!percent) {
            loading.setText('正在下载...');
          } else if (downloadedMB < 1) {
            loading.setText(`正在下载 ${percent}% (${(downloadedMB * 1024).toFixed(0)} KB)...`);
          } else {
            loading.setText(`正在下载 ${percent}% (${downloadedMB.toFixed(1)} MB)...`);
          }
        },
      })
      .then(() => { this.$message.success('下载成功'); })
      .catch(err => {
        if (err.name !== 'AbortError') {
          console.error(err);
          this.$message.error(err.message || '下载失败');
        }
      })
      .finally(() => { loading.close(); });
    },
    async previewPdf(scope,file) {
      try {
        const loading = this.$loading({
          lock: true,
          text: '加载文件中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        let fileName=file.fileName;
        let dataType="";
        let dataId="";
        if(scope.row.level==0){
          dataType="1";
          dataId=scope.row.channelId;
        }else if(scope.row.level==1){
          dataType="2";
          dataId=scope.row.merchantId;
        }
        await axios.get('/couponScreening/file/previewPdfFile', {
          params: {
            dataId: dataId,
            dataType: dataType,
            fileName: fileName,
            fileId: file.fileId
          },
          responseType: "blob",
        }).then(response => {
          loading.close();
          if (fileName.endsWith('.pdf') || fileName.endsWith('.PDF')) {
            const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
            window.open(url, "_blank");
          }else if (fileName.endsWith('.jpg') || fileName.endsWith('.jpeg')) {
            const url = window.URL.createObjectURL(new Blob([response.data], { type: 'image/jpeg' }));
            window.open(url, "_blank");
          }else if (fileName.endsWith('.png')) {
            const url = window.URL.createObjectURL(new Blob([response.data], { type: 'image/jpeg' }));
            window.open(url, "_blank");
          }else if (fileName.endsWith('.xlsx') || fileName.endsWith('.XLSX') || fileName.endsWith('.xls') || fileName.endsWith('.XLS')) {
            if(this.userRole == "3"){
              this.previewExcel(scope.row.channelId,fileName);
            }else{
              const mimeType = fileName.endsWith('.xlsx') || fileName.endsWith('.XLSX')
                ? 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                : 'application/vnd.ms-excel';
                const blob = new Blob([response.data], { type: mimeType });
                const url = window.URL.createObjectURL(blob);
                const aLink = document.createElement('a');
                aLink.href = url;
                aLink.download = file.fileAliasName;
                document.body.appendChild(aLink);
                aLink.click();
                document.body.removeChild(aLink);
                window.URL.revokeObjectURL(url);
                this.$message({ message: '开始下载 Excel 文件', type: 'success' });
            }
          }
        });
      } catch (error) {
        this.$message({
          message: '预览文件失败!',
          type: 'error'
        });
      }
    },
    async fileDownTxt(channelId){
      try {
        const response = await axios.get(`/couponScreening/file/downloadTxt?channelId=`+channelId, {
          responseType: 'blob',
          headers: {
            'Accept': 'text/plain'
          }
        })
        const contentDisposition = response.headers['content-disposition'];
        let fileName = '审批意见.txt';
        const blob = new Blob([response.data], { type: 'text/plain;charset=utf-8' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error('下载失败', error);
      }
    },
    previewExcel(channelId,fileName) {
      const loading = this.$loading({
        lock: true,
        text: "正在下载...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      let type = "";
      if(fileName.indexOf("销售企业信息汇总表")!=-1){
        type = "0";
      }else if(fileName.indexOf("线上或线下参与补贴实施的门店信息汇总表")!=-1){
        type = "1";
      }
      preview({
        channelId:channelId,
        auditState: this.searchForm.auditState,
        type:type
      }).then((res) => {
        loading.close();
        let blob = new Blob([res]);
        let url = window.URL.createObjectURL(blob); // 创建 url 并指向 blob
        let a = document.createElement("a");
        a.href = url;
        a.target = "_blank";
        a.rel = "noopener noreferrer";
        a.download = fileName;
        a.click();
        window.URL.revokeObjectURL(url); // 释放该 url
        this.$message.success("下载成功");
      }).catch(error => {
        loading.close();
        this.$message.error("下载失败");
      });
    },
    getSelectedLevelData(){
      let data = {
        channelList: []
      };
      this.tableData.forEach(channel => {
        if(channel.checked){
          let channelItem = {
            id: channel.channelId,
            flowId: channel.parentId,
            merchantList: []
          };
          data.channelList.push(channelItem);
          if(channel.children && channel.children.length>0){
            channel.children.forEach(merchant => {
              if(merchant.checked){
                let merchentItem = {
                  id: merchant.id,
                  storeList: []
                };
                channelItem.merchantList.push(merchentItem);
                if(merchant.children && merchant.children.length>0){
                  merchant.children.forEach(store => {
                    if(store.checked){
                      merchentItem.storeList.push({
                        id: store.id
                      });
                    }
                  })
                }
              }
            })
          }
        }
      });
      return data;
    },
    getSelectedCheckbox(){
      let data=[];
      this.tableData.forEach(channel => {
        if(channel.checked){
          data.push(channel);
          if(channel.children && channel.children.length>0){
            channel.children.forEach(merchent => {
              if(merchent.checked){
                data.push(merchent);
                if(merchent.children && merchent.children.length>0){
                  merchent.children.forEach(store => {
                    if(store.checked){
                      data.push(store);
                    }
                  })
                }
              }
            })
          }
        }
      });
      if (data.length == 0) {
        if(this.exportFlag!='3'){
          this.$message({
            message: '请选择记录！',
            type: 'warning'
          });
        }
        return data;
      }else{
        return data;
      }
    },
    getSelectedIds(){
      if(this.exportFlag=='3' && !this.getSelectedCheckbox()){
        return;
      }
      let selectedData = this.getSelectedCheckbox();
      let data={
        workFlowIds:'',
        channleIds:'',
        merchanIds:'',
        storeIds:'',
      };
      selectedData.forEach(item => {
        if(item.level=="0"){
          data.workFlowIds += item.flowId+",";
          data.channleIds += item.channelId+",";
        }else if(item.level=="1"){
          data.merchanIds += item.merchantId+",";
        }else if(item.level=="2"){
          data.storeIds += item.storeId+",";
        }
      });
      if(data.workFlowIds!=""){
        data.workFlowIds=data.workFlowIds.substring(0,data.workFlowIds.length-1);
      }
      if(data.channleIds!=""){
        data.channleIds=data.channleIds.substring(0,data.channleIds.length-1);
      }
      if(data.merchanIds!=""){
        data.merchanIds=data.merchanIds.substring(0,data.merchanIds.length-1);
      }
      if(data.storeIds!=""){
        data.storeIds=data.storeIds.substring(0,data.storeIds.length-1);
      }
      return data;
    },
    setJoinOrExitDate(flag){
      if(flag=="0"){
        let data = this.getSelectedCheckbox();
        if(data.length==0){
          this.$message.error("请选择记录");
          return;
        }
        let message="";
        for (const item of data) {
          if (item.level=="0" && (item.publicityDate==null || item.publicityDate=="")) {
            message = "请选择已公示的记录！";
            break;
          }
        }
        if(message!=""){
          this.$message.error(message);
          return;
        }
        this.dialogFormVisible=true;
      }else{
        this.dialogFormVisible=false;
      }
    },
    saveJoinOrExitDate(state){
      const loading = this.$loading({
        lock: true,
        text: '提交中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      let param=this.getSelectedIds();
      setJoinDate({
        channelIds: param.channleIds,
        merchantIds: param.merchanIds,
        joinDate: this.joinOrExitDate
      }).then((res) => {
        if (res.code === '200') {
          this.onSearch();
          this.$message({
            type: "success",
            message: "提交成功!"
          });
          this.dialogFormVisible=false;
        } else {
          this.$message.error(res.message);
        }
        loading.close();
      });
    },
    addMerchant(wfType){
      if(this.userRole=="1" && this.term.isInRange==false){
        this.$message.error(this.term.info);
        return;
      }
      this.$router.push({
        path: `/sys/linXuanChannel/merchantIndex/1/${wfType}/all/ `
      });
    },
  }
};
</script>

<style scoped>
.btn_box {
  text-align: right;
  margin-top: 8px;
  height: 40px;
}

.flex-container {
  height: 100%;
  display: flex;
  flex-direction: column;
  text-align: center;
}
.tishi{
  position: absolute;
  top: 50%;
  left:50%;
  margin-top: -14px;
  margin-left: -100px;
  font-size: 16px;
  color: #333;
  font-weight: 500;
}
.flex-item:nth-child(1),
.flex-item:nth-child(2),
.flex-item:nth-child(4) {
  flex-grow: 0;
  flex-shrink: 0;
}

.flex-item:nth-child(3) {
  flex-grow: 1;
  flex-shrink: 1;
  overflow-y: auto;
}

.pagination {
  margin-top: 8px;
}

.flex-item:nth-child(1),
.flex-item:nth-child(2),
.flex-item:nth-child(4) {
  flex-grow: 0;
  flex-shrink: 0;
}

.flex-item:nth-child(3) {
  flex-grow: 1;
  flex-shrink: 1;
  overflow-y: auto;
}
/* 表头容器样式：横向排列 */
::v-deep .selection-header {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding-left: 8px;
  width: 100%;
}

/* 原生复选框容器样式 */
::v-deep .original-checkbox {
  margin-right: 8px;
}

/* 按钮样式优化 */
::v-deep .selection-header .el-button--text {
  padding: 0 4px;
  font-size: 12px;
  color: #409EFF;
}

/* 去除按钮hover背景（可选） */
::v-deep .selection-header .el-button--text:hover {
  background: transparent;
  color: #66b1ff;
}
/* 隐藏表格默认的树形箭头 */
::v-deep .custom-tree-table .el-table__expand-icon {
  display: none !important;
}

/* 自定义箭头样式，与名称文本对齐 */
::v-deep .tree-expand-icon {
  cursor: pointer;
  margin-right: 8px;
  font-size: 14px;
  color: #666;
}

/* 名称文本样式 */
::v-deep .name-text {
  vertical-align: middle;
}

/* 调整序号列、复选框列的单元格内边距，布局更紧凑 */
::v-deep .custom-tree-table .el-table__cell {
  padding: 8px 5px !important;
}
.table-page {
  width: 100%;
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.table-page >>> .el-table {
  flex: 1;
  min-height: 0;
}
/* 横向滚动条样式（作用于表格 body 区域） */
.table-page .el-table__body-wrapper {
  overflow-x: auto !important;
}
.table-page .el-table__body-wrapper::-webkit-scrollbar {
  height: 8px;
}
.table-page .el-table__body-wrapper::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}
.table-page .el-table__body-wrapper::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 4px;
}
.table-page .el-table__body-wrapper::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}
</style>